import * as fromDatatype from '../datatype-library/index';

export interface bl_pgw_contract_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  pgwc_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  contract_credentials: fromDatatype.JsonDatatypeInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_pgw_contract_hdr_RowClass implements bl_pgw_contract_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  payment_channel_guid: fromDatatype.GuidDataFieldInterface;
  pgwc_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeClass;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldClass;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldClass;
  vrsn: fromDatatype.VrsnDataFieldClass;
  contract_credentials: fromDatatype.JsonDatatypeClass;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
}
